import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FS3ValidationResult} from "../../../objects/validationResult";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {ListItem} from "../../../objects/listItem";
import {SharedDataService} from "../../../services/shared-data.service";
import {FS3Notification} from "../../../objects/notification";
import {environment} from "../../../../environments/environment";
import {AppEvent} from "../../../objects/appEvent";

@Component({
  selector: 'app-subscribe-event-form',
  templateUrl: './subscribe-event-form.component.html',
  styleUrls: ['./subscribe-event-form.component.scss']
})
export class SubscribeEventFormComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() success = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  private formValidationMessages = {
    required: 'Value required.',
  };
  public validationResult: FS3ValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public textInput: FormControl = new FormControl('', [Validators.required, this.formValidator()]);
  public eventDateInput: FormControl = new FormControl('', [Validators.required, this.formValidator()]);
  public eventHourInput: FormControl = new FormControl('');
  public eventDeadlineInput: FormControl = new FormControl('', [Validators.required, this.formValidator()]);
  public deadlineHourInput: FormControl = new FormControl('');
  state: string = 'edit';
  errMsg: string = '';
  public listItem: ListItem;

  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.componentForm.addControl('textInput', this.textInput);
    this.componentForm.addControl('eventDateInput', this.eventDateInput);
    this.componentForm.addControl('eventHourInput', this.eventHourInput);
    this.componentForm.addControl('eventDeadlineInput', this.eventDeadlineInput);
    this.componentForm.addControl('deadlineHourInput', this.deadlineHourInput);
    //this.textInput.setValue('')
    let d1 = new Date();
    d1.setTime(d1.getTime()+2*24*3600*1000);
    this.eventDateInput.setValue(d1);
    let d2 = new Date();
    d2.setTime(d2.getTime()+24*3600*1000);
    this.eventDeadlineInput.setValue(d2);
    //this.dateInput.disable()
    this.eventHourInput.setValue('00:00')
    this.deadlineHourInput.setValue('22:00')
    //this.textInput.setValue(this.listItem.itemFullData['static_html_alias'])
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }

    if (!this.textInput.valid) {
      this.textInput.markAsTouched()
      const errorKey = Object.keys(this.textInput.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.textInput.errors[errorKey] // get error string by errorKey
      };
      return false;
    } if (!this.eventDateInput.valid && this.eventDateInput.errors) {
      this.eventDateInput.markAsTouched()
      const errorKey = Object.keys(this.eventDateInput.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.eventDateInput.errors[errorKey] // get error string by errorKey
      };
      return false;
    } if (!this.eventDeadlineInput.valid && this.eventDeadlineInput.errors) {
      this.eventDeadlineInput.markAsTouched()
      const errorKey = Object.keys(this.eventDeadlineInput.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.eventDeadlineInput.errors[errorKey] // get error string by errorKey
      };
      return false;
    } else {
      this.validationResult = null; //hide validationResult leftovers
    }

    this.updateEvent();
    this.state = 'loading';

    return false
  }

  private updateEvent() {
    let eventDate = ((this.eventDateInput.value as Date).getTime())/1000;
    let deadlineDate = ((this.eventDeadlineInput.value as Date).getTime())/1000;
    let configToSave = {
      label: this.textInput.value,
      event_day: eventDate,
      event_hours: this.eventHourInput.value,
      deadline_day: deadlineDate,
      deadline_hours: this.deadlineHourInput.value,
      class_id: this.payload['classItem']['id'],
      class_name: this.payload['classItem']['name'],
    }
    this.application.apiService
      .updateEventItem(
        environment['gid'],environment['g_hash'], this.payload['classItem']['uuid'],
        this.payload['item'] ? this.payload['item']['id'] : null,
        'club_event','event_subscription_opened',configToSave)
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Subscription event has been saved!';
          this.sharedDataService.pushNotification(notification);
          if(!this.payload['item']) { //append new item to list
            let listItem = this.application.apiService.extractClubEventsData([data])[0];
            let appEvent = new AppEvent(AppEvent.CLASS_EVENT_ADDED,{"listItem": listItem,"class_uuid":this.payload['classItem']['uuid']});
            this.sharedDataService.pushAppEvent(appEvent)
          }
          this.success.emit()
        },
        error => {
          const { exception } = error;
          const errMsg = error['errMsg'] ? error['errMsg'] : (
            (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
          );
          let notification = new FS3Notification();
          notification.type = 'error';
          notification.text = errMsg;
          this.sharedDataService.pushNotification(notification);
          this.state = 'edit'
          this.validationResult = {
            isValid: false,
            message: errMsg
          };
        }
      )
  }

  private formValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const value = control.value.toString().replace(/ /g, '');
      if (!value) {
        return {required: this.formValidationMessages.required}
      }

      // if (isNaN(value*1) || parseFloat(value) != parseInt(value)) {
      //   return {onlyDigitsRequired: this.formValidationMessages.onlyDigitsRequired}
      // }
      //
      // if (Math.abs(control.value) > 9999) {
      //   return {maxValueForbidden: this.formValidationMessages.maxValueForbidden}
      // }

      return null;
    };
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

}
